import React from "react";
import {observer} from "mobx-react";
import {MdCheckbox, MdTextField} from "core/components/fields/fields";
import {DialogAncestor, DialogProps} from "core/common/page/dialogAncestor";
import { action, observable } from 'mobx';
import Dialog from "material-ui/Dialog";
import FlatButton from "material-ui/FlatButton";
import {Party, SelectableHolderWithPartyLov} from "party/partyDomain";
import {lovLabel, lovValue} from "core/form/formUtils";
import {addTenantToQuery} from "core/common/utils/utils";
import {Link} from "react-router";
import styled from "styled-components";
import validator from 'validator';
import partyService from "party/partyService";


const _label_style = {fontSize: 13};

interface EmailAddressesEditorProps {
  emails: SelectableHolderWithPartyLov<string>[];
}

interface EmailAddressesEditorState {
  addEmailText?: string;
  addEmailError?: string;
}

const FlexRowDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: start;
  gap: 10px;
`;

@observer
export class EmailAddressesEditor extends React.Component<EmailAddressesEditorProps, EmailAddressesEditorState> {

  componentWillMount() {
    this.setState({
      addEmailText: '',
      addEmailError: ''
    });
  }

  // @action onDismiss = () => {
  //   const objekt = this.props.objekt;
  //   if (objekt.tupleMap) {
  //     objekt.tupleMap.emailedPersons = undefined;
  //     objekt.tupleMap.excludedPersons = undefined;
  //   }
  // };

  @action onCheckSelected = (index, evt, checked) => {
    let {emails} = this.props;
    let holder = emails[index];
    console.log('onCheckSelected', holder, evt, checked);
    holder.selected = checked;
  };

  @action onChangeAddEmail = (evt) => {
    this.setState({addEmailText: evt.target.value});
  };

  @action addEmail = (evt) => {
    if (validator.isEmail(this.state.addEmailText)) {
      partyService.searchParty(this.state.addEmailText)
        .then((parties: Party[]) => {
          let party = parties.pop();
          this.props.emails.push({
            value: this.state.addEmailText,
            selected: true,
            partyLov: (party) ? party.partyLov() : undefined
          });
          this.setState({
            addEmailText: '',
            addEmailError: ''
          });
        });
    } else {
      this.setState({
        addEmailText: this.state.addEmailText,
        addEmailError: "Email is not valid"
      });
    }
  };

  render() {
    const {emails} = this.props;
    return (
      <div>
        {emails.map((holder, index) => (
          <FlexRowDiv key={index}>
            <div>
              <MdCheckbox name={holder.value} checked={holder.selected} labelStyle={_label_style}
                          label={holder.value} onCheck={this.onCheckSelected.bind(this, index)}/>
            </div>
            {holder.partyLov &&
            <Link to="partyDetail" style={{fontSize: 13}} params={{id: lovValue(holder.partyLov)}}
                  query={addTenantToQuery()}>{" (" + lovLabel(holder.partyLov) + ")"}</Link>
            }
          </FlexRowDiv>
        ))}

        <FlexRowDiv>
          <MdTextField value={this.state.addEmailText} name="addEmailTextField" errorText={this.state.addEmailError} onChange={this.onChangeAddEmail}
                       hintText="Add another email"/>
          <FlatButton label="Add Email" secondary onClick={this.addEmail}/>
        </FlexRowDiv>

      </div>
    )
  };
}

interface EmailAddressesEditorDialogState {
  title?: string;
}

export type EmailAddressesEditorDialogReturnType = {
  emails: SelectableHolderWithPartyLov<string>[];
  insertSeparateDocsIntoMain: boolean;
}

@observer
export class EmailAddressesEditorDialog extends DialogAncestor<DialogProps, EmailAddressesEditorDialogState, EmailAddressesEditorDialogReturnType> {

  dto: EmailAddressesEditorProps;
  @observable insertSeparateDocsIntoMain: boolean;
  showIncludeSeparate: boolean;

  @action open(resolve, reject, dto: EmailAddressesEditorProps, showIncludeSeparate: boolean, title?: string) {
    this.resolve = resolve;
    this.reject = reject;
    this.dialogOpen = true;
    this.dto = dto;
    this.insertSeparateDocsIntoMain = false;
    this.showIncludeSeparate = showIncludeSeparate;
    this.setState({
      title
    });
  }

  @action sendHandler = (evt) => {
    console.log('EmailAddressesEditorDialog#ok evt = %O', evt);

    this.dialogOpen = false;
    this.$errors = [];
    this.resolve({emails: this.dto.emails, insertSeparateDocsIntoMain: this.insertSeparateDocsIntoMain} );
  };


  @action cancelHandler = (evt) => {
    console.log('EmailAddressesEditorDialog#cancel evt = %O', evt);
    this.dialogOpen = false;
    this.$errors = [];
    this.reject("cancel");
  };

  // @action onChangeCertFormat = (lovItem) => {
  //   console.log('onChangeCertFormat lovItem = %O', lovItem);
  //   this.dto.certFormat = lovItem;
  //   this.dto.password = "";
  // };
  // @action onChangePassword = (evt) => {
  //   this.dto.password = evt.target.value;
  // };
  //

  render() {
    if (!(this.dialogOpen)) return null;


    return (
      <Dialog
        title={this.state.title}
        actions={[<FlatButton key="1" label="Send !" secondary onClick={this.sendHandler}
                              disabled={this.dto.emails.filter(e => e.selected).length == 0}/>,
          <FlatButton key="2" label="Cancel" primary onClick={this.cancelHandler}/>]}
        modal={true}
        open={this.dialogOpen}
        bodyStyle={{minHeight: 180}}
        contentStyle={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          filter: 'blur(0)'
        }}
      >

        <EmailAddressesEditor emails={this.dto.emails}/>

        {this.showIncludeSeparate && (
          <div style={{marginTop: 20}}>
            <MdCheckbox name="insertSeparateDocsIntoMain" checked={this.insertSeparateDocsIntoMain}
                        labelStyle={_label_style}
                        label="Insert separate docs into main document"
                        onCheck={e => this.insertSeparateDocsIntoMain = e.target.checked} />
          </div>
        )
        }

      </Dialog>
    );
  }


}



// WEBPACK FOOTER //
// ./src/core/event/component/emailComponents.tsx